import { LanguageReducer } from '@web_opxp/language';
import { combineReducers } from 'redux';
import { AppReducer } from '../app';

const reducer = combineReducers({
  [LanguageReducer.statePropName]: LanguageReducer.default,
  [AppReducer.statePropName]: AppReducer.default,
});

type TRootState = ReturnType<typeof reducer>;

export const initialState: TRootState = {
  [LanguageReducer.statePropName]: LanguageReducer.initialState,
  [AppReducer.statePropName]: AppReducer.initialState,
};

export default reducer;
